var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTollingAppBig(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.8825 13.4844C29.1494 11.2175 32.8248 11.2174 35.0918 13.4844",
    stroke: "#193232",
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1914 11.1406C27.7538 7.57825 33.5294 7.5782 37.0918 11.1406",
    stroke: "#193232",
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0004 8.79688C26.8581 3.93909 34.7341 3.9392 39.5918 8.79688",
    stroke: "#193232",
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22 24H38.9412M22 45H38.9412",
    stroke: "#193232",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M36.9481 20H23.9931C22.8923 20 22 20.9551 22 22.1333V49.8667C22 51.0449 22.8923 52 23.9931 52H36.9481C38.0488 52 38.9412 51.0449 38.9412 49.8667V22.1333C38.9412 20.9551 38.0488 20 36.9481 20Z",
    stroke: "#193232",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4412 49C30.961 49 31.3824 48.5523 31.3824 48C31.3824 47.4477 30.961 47 30.4412 47C29.9214 47 29.5 47.4477 29.5 48C29.5 48.5523 29.9214 49 30.4412 49Z",
    stroke: "#193232",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTollingAppBig);
export default __webpack_public_path__ + "static/media/tolling-app-big.eb8fe1fea6570b3572606db8c11a668a.svg";
export { ForwardRef as ReactComponent };